import _ from "lodash"
import React from "react"
import { Checkbox } from "react-bootstrap"

export class FacetCheckbox extends React.Component {
  handleChange = () => {
    this.props.onSelectionChange(
      this.props.attributeName,
      this.props.value,
      !this.props.selected
    )
  }

  render() {
    const {
      count,
      disableAdd,
      facetConfiguration,
      valueLabel,
      selected,
    } = this.props
    console.log('props', this.props)
    let label = valueLabel
    if (_.isNumber(count) && facetConfiguration.showCount) {
      label = (
        <span>
          {label}&nbsp;({count})
        </span>
      )
    }

    return (
      <div style={{ display: 'flex' }} className="facet-checkbox">
        <Checkbox
          disabled={disableAdd && !selected}
          type={"checkbox"}
          checked={selected}
          onChange={this.handleChange}
        />
        <p style={{ paddingTop: 9 }}>{label}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/facets/components/FacetCheckbox.js